import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { NavLink } from "react-router-dom";

import Base from "../core/static/Base";
import { forgotPassword } from "./helper";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({
    loading: false,
    success: "",
    error: "",
  });

  const handleEmailChange = (event) => {
    setEmail(event.target.value);

    setStatus({
      loading: false,
      success: "",
      error: "",
    });
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    const cleanedEmail = email.toLowerCase().trim();

    if (!cleanedEmail) {
      setStatus({
        loading: false,
        success: "",
        error: "Please enter your email address.",
      });

      return;
    }

    setStatus({
      loading: true,
      success: "",
      error: "",
    });

    const data = await forgotPassword(cleanedEmail);

    if (data.error) {
      setStatus({
        loading: false,
        success: "",
        error: data.error,
      });

      return;
    }

    setStatus({
      loading: false,
      success:
        data.message ||
        "If an account exists with this email address, a password reset link has been sent.",
      error: "",
    });

    setEmail("");
  };

  return (
    <div>
      <Helmet>
        <title>Scope Ebook - Forgot Password</title>
      </Helmet>

      <Base>
        <div className="row">
          <div className="contact-us section" id="contact">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="contact-us-content">
                    <div className="row">
                      <div
                        className="col-lg-4"
                        style={{ margin: "auto" }}
                      >
                        <img
                          src="/images/scopeEbook.png"
                          alt="Scope Ebook"
                        />
                      </div>

                      <div className="col-lg-8">
                        <form
                          id="contact-form"
                          onSubmit={onSubmit}
                        >
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="section-heading">
                                <h2>
                                  <em>Forgot Password</em>
                                </h2>

                                <p>
                                  Enter your registered email address.
                                  We will send you a password reset
                                  link.
                                </p>

                                {status.success && (
                                  <div
                                    className="alert alert-success"
                                    role="alert"
                                  >
                                    {status.success}
                                  </div>
                                )}

                                {status.error && (
                                  <div
                                    className="alert alert-danger"
                                    role="alert"
                                  >
                                    {status.error}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-12">
                              <fieldset>
                                <input
                                  type="email"
                                  name="email"
                                  id="forgot-password-email"
                                  placeholder="Enter your email"
                                  value={email}
                                  onChange={handleEmailChange}
                                  autoComplete="email"
                                  required
                                />
                              </fieldset>
                            </div>

                            <div className="col-lg-12">
                              <fieldset>
                                <button
                                  type="submit"
                                  id="forgot-password-submit"
                                  className="orange-button"
                                  disabled={status.loading}
                                >
                                  {status.loading
                                    ? "Sending..."
                                    : "Send Reset Link"}
                                </button>
                              </fieldset>
                            </div>

                            <div className="col-lg-12 text-center mt-3">
                              <NavLink to="/login">
                                Back to Login
                              </NavLink>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Base>
    </div>
  );
};

export default ForgotPassword;